const LocalStorage = () => {
  const localStorageInfo = typeof window !== 'undefined' ? localStorage.getItem("token_verify") : '';
  const UserInfo = typeof window !== 'undefined' ? localStorage.getItem("users") : null;

  //   const user_decodedStringAtoB = atob(localStorageInfo);
  //   const user_info = JSON.parse(user_decodedStringAtoB);
  //   console.log(user_info);
  const access_token = localStorageInfo;
  const user = JSON.parse(UserInfo);
  return { access_token, user };
}

export default LocalStorage
